
import { Component, Prop, Vue, Watch, Ref, Mixins, PropSync } from "vue-property-decorator";
import UploadImg from "@/components/uploadImg.vue";
import config from "@/config/default";
import ETable from "@/components/ETable.vue";
import TablePagination from "@/mixins/tablePagination";
import Resize from "@/mixins/resize";
import { editNewPlan, getMerchantProductList } from "@/api/symptoms";
import { Form } from "element-ui/types";
import { cloneDeep } from "lodash";

@Component({
    components: {
        ETable,
        UploadImg,
    }
})
export default class NewProjectDialog extends Mixins(Vue, TablePagination, Resize) {
    // @Ref("form") formRef: Form;
    @Ref("validateForm") formRef: Form;
    @Ref("transferRef") transferRef: any;
    @PropSync("formData") private formDataSync!: any;
    // @Prop() private formDataSync!: any;
    @Prop([String]) private dialogTitle!: string;
    @Prop([Boolean]) private dialogVisible!: boolean;
    @Prop() private merchantId!: string | number;
    // 初始数据可以直接声明为实例的 property
    // roleList: Array<Role> = [];

    formRules = {
        planName: { required: true, message: "请输入名称", trigger: "blur" },
        careMethod: { required: true, message: "请输入调理方法", trigger: "blur" },
        effect: { required: true, message: "请输入作用", trigger: "blur" },
        symptomsImgs: { required: true, message: "请上传图片", trigger: "blur" },
        relationList: { required: true, type: "array", message: "请选择产品", trigger: "blur" }
    };

    columns = [
        { label: "序号", width: "60px", type: "index" },
        { label: "名称", prop: "caseName" },
        { label: "图片", prop: "caseImgUrl" },
        { label: "操作", prop: "action" }
    ];

    fileList = [];
    uploadImageUrl = `${config.uploadImg}permutation`;
    dialogImageUrl = ""; // 图片预览
    dialogPreviewVisible = false;
    saveLoading = false;

    bodyOptions = [];

    productList = [];


    created() {
        this.getMerchantProductList();
    }

    mounted() {
        this.windowResize(320);
    }

    getMerchantProductList() {
        getMerchantProductList({ merchantId: this.merchantId }).then((res) => {
            console.log("res", res)
            this.productList = res.data;
        })
    }

    dialogClose() {
        this.fileList = [];
        this.$emit("closeProjectDialog");
        this.saveLoading = false;
        this.formRef?.resetFields();
        this.formDataSync.newPlan = [{
            careMethod: "",
            effect: "",
            planName: "",
            symptomsImgs: []
        }];
    }

    handleEdit() {
        if (this.formDataSync.newPlan.length >= 6) return;
        this.formDataSync.newPlan.push({
            planName: "",
            careMethod: "",
            effect: "",
            symptomsImgs: []
        });
    }

    deleteRow(index) {
        // if (this.formDataSync.caseList.length <= 1) return;
        this.formDataSync.newPlan.splice(index, 1);
    }

    shouldShowTooltip(categoryName: string) {
        if (!categoryName) return false;

        // 创建一个临时的 span 元素来测量文本宽度
        const tempSpan = document.createElement('span');
        tempSpan.style.cssText = `
            position: absolute;
            visibility: hidden;
            white-space: nowrap;
            font-size: 14px;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
        `;
        tempSpan.textContent = categoryName;
        document.body.appendChild(tempSpan);

        const textWidth = tempSpan.offsetWidth;
        document.body.removeChild(tempSpan);

        const maxWidth = 200;
        return textWidth > maxWidth;
    }

    dialogConfirm() {
        this.formRef?.validate((valid) => {
            if (valid) {
                const params = cloneDeep(this.formDataSync);
                params.merchantId = this.merchantId;
                console.log(params)
                params.newPlan?.forEach((plan) => {
                    const { relationList } = plan;
                    const _relationList = relationList?.map(pId => this.productList?.find(pro => pro.id == pId));
                    plan.relationList = _relationList?.map((el) => {
                        return { productId: el.id, planProduct: el.categoryName }
                    })
                })

                editNewPlan(params).then((res) => {
                    this.$message.success("保存成功");
                    this.$emit('projectDialogConfirm');
                    this.dialogClose();
                });
            } else {
                return false;
            }
        })

    }
}
